module.exports = "pegasus/assets/styleGroup2-pinterest.gif";